import type { FC } from 'react'

export type InputErrorProps = {
	error?: string
}

export const InputError: FC<InputErrorProps> = ({ error }) => {
	return error ? <p className="text-body-xs text-error">{error}</p> : null
}

export default InputError
